<template>
    <zen-message-modal :isOpen="isOpen" title="Token created">
        <p class="text-sm text-taupe-500 mb-4">
            Copy this token now — it will not be shown again.
        </p>
        <div
            class="flex items-center gap-2 rounded-md border border-taupe-200 bg-taupe-50 px-3 py-2 font-mono text-sm break-all"
        >
            <span class="flex-1 select-all">{{ token }}</span>
            <zen-button variant="secondary" size="small" @click="$emit('copy')">
                {{ copied ? 'Copied!' : 'Copy' }}
            </zen-button>
        </div>
        <template v-slot:buttons>
            <zen-button variant="primary" @click="$emit('close')">
                Done
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'ApiTokenCreatedModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        token: {
            type: String,
            default: null,
        },
        copied: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'copy'],
}
</script>
